import { SCOPE_HANDLER_SESSION_KEY } from './constants/index.js';
var ScopeHandler = (function () {
    function ScopeHandler() {
        this.scope = '';
        var persistedScope = window.localStorage.getItem(SCOPE_HANDLER_SESSION_KEY);
        if (!persistedScope) {
            return;
        }
        var scope = JSON.parse(persistedScope).scope;
        this.scope = scope;
    }
    ScopeHandler.prototype.persist = function (scope) {
        this.scope = scope;
        window.localStorage.setItem(SCOPE_HANDLER_SESSION_KEY, JSON.stringify({
            scope: scope,
        }));
    };
    ScopeHandler.prototype.clear = function () {
        this.scope = '';
        window.localStorage.removeItem(SCOPE_HANDLER_SESSION_KEY);
    };
    return ScopeHandler;
}());
export default ScopeHandler;
//# sourceMappingURL=ScopeHandler.js.map